import React from "react";

/**
 * The shared "big center canvas" every Studio renders its primary result into.
 * Has four states:
 *   - idle: shows the empty-state message + icon ("Your thing will appear here")
 *   - processing: shows a loading spinner + status text
 *   - complete: shows children (the result content — typically a result grid)
 *   - failed: shows an error state with retry option
 *
 * Each Studio decides what `complete` renders by passing it as children.
 */
export default function StudioCanvas({
  status = "idle",
  emptyMessage = "Your result will appear here",
  emptyIcon = "✨",
  loadingMessage = "Generating...",
  errorMessage,
  onRetry,
  children,
}) {
  if (status === "idle") {
    return (
      <div className="studio-canvas studio-canvas-idle">
        <div className="studio-canvas-empty">
          <div className="studio-canvas-empty-icon">{emptyIcon}</div>
          <div className="studio-canvas-empty-text">{emptyMessage}</div>
        </div>
      </div>
    );
  }

  if (status === "processing") {
    return (
      <div className="studio-canvas studio-canvas-processing">
        <div className="studio-canvas-spinner" />
        <div className="studio-canvas-status">{loadingMessage}</div>
      </div>
    );
  }

  if (status === "failed") {
    return (
      <div className="studio-canvas studio-canvas-failed">
        <div className="studio-canvas-failed-icon">⚠</div>
        <div className="studio-canvas-failed-text">
          {errorMessage || "Generation failed"}
        </div>
        {onRetry && (
          <button className="studio-canvas-retry-btn" onClick={onRetry}>
            Try again
          </button>
        )}
      </div>
    );
  }

  // status === 'complete'
  return <div className="studio-canvas studio-canvas-complete">{children}</div>;
}
